// 加载中图标
import { CircularProgress } from '@mui/material';
const LoadingIcon = () => {
  return <CircularProgress size={16} sx={{ color: '#fff' }} />;
};
export default LoadingIcon;
